<template>
  <div>
    <div class="app-content content">
      <div>
        <navbarUser />
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
        <div v-if="showBtn == true && (roleUser == 5 || roleUser == 4)" class="content_btn">
          <div class="btn_update_data">
            <button
              @click="irUpdateData()"
              type="button"
              class="btn btn-success"
              title="Actualiza tus datos y obtén 20 puntos"
            >
              Actualiza tus datos
            </button>
          </div>
        </div>
        <footerLanding />
      </div>
    </div>

    <!-- Modal de recuperar contraseña -->
    <div
      class="modal fade "
      id="exampleModal"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content modal-question">
          <div class="modal-body">
            <div class="mt-2 row justify-content-center">
              <div class="col-12 col-md-11 col-lg-10 col-xl-10 col-sm-12 ">
                <label style="color: #616161;">
                  <b>
                    Cambia tu contraseña para ingresar a tu cuenta en el club
                  </b> </label
                ><br />
              </div>
              <div class="col-12 mt-2">
                <div class="row justify-content-center">
                  <div class="col-12 col-md-7 col-lg-5 col-xl-5 col-sm-12 ">
                    <div class="form-group">
                      <div class="input-group mb-3">
                        <i class="fa fa-lock icon"></i>
                        <input
                          :class="{ 'is-danger': errors.currentPassword }"
                          v-model="form.currentPassword"
                          type="password"
                          ref="current_password"
                          class="form-control color-input-change"
                          aria-label="Email"
                          placeholder="Contraseña actual"
                          aria-describedby="basic-addon1"
                        />
                        <div @click="showPass(1)" class="eye_pass">
                          <i id="pass1" class="fa-regular fa-eye-slash"></i>
                        </div>
                      </div>
                      <span
                        v-if="errors.currentPassword"
                        class="text-danger float-left small error-danger"
                        >{{ errors.currentPassword }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-12 col-md-7 col-lg-5 col-xl-5 col-sm-12">
                    <div class="form-group">
                      <div class="input-group mb-3">
                        <i class="fa fa-lock icon"></i>
                        <input
                          :class="{ 'is-danger': errors.pass }"
                          v-model="form.pass"
                          type="password"
                          ref="password"
                          class="form-control color-input-change"
                          aria-label="Email"
                          placeholder="Contraseña nueva"
                          aria-describedby="basic-addon1"
                        />
                        <div @click="showPass(2)" class="eye_pass">
                          <i id="pass2" class="fa-regular fa-eye-slash"></i>
                        </div>
                      </div>
                      <span
                        v-if="errors.pass"
                        class="text-danger float-left small error-danger"
                        >{{ errors.pass }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-12 col-md-7 col-lg-5 col-xl-5 col-sm-12">
                    <div class="form-group">
                      <div class="input-group mb-3">
                        <i class="fa fa-unlock-alt icon" aria-hidden="true"></i>
                        <input
                          :class="{ 'is-danger': errors.pass_confirmation }"
                          v-model="form.pass_confirmation"
                          type="password"
                          ref="confirm_password"
                          class="form-control color-input-change"
                          aria-label="Password"
                          placeholder="Confirmar contraseña nueva"
                          aria-describedby="basic-addon1"
                        />
                        <div @click="showPass(3)" class="eye_pass">
                          <i id="pass3" class="fa-regular fa-eye-slash"></i>
                        </div>
                      </div>
                      <span
                        v-if="errors.pass_confirmation"
                        class="text-danger float-left small error-danger"
                        >{{ errors.pass_confirmation }}</span
                      >
                    </div>
                  </div>
                </div>
                <div class="row  justify-content-center">
                  <div class="col-12 col-md-10 col-lg-6 col-xl-6 col-sm-12">
                    <label style="color: #616161;">
                      Recuerda usar letras y números para hacer tu contraseña
                      más segura. </label
                    ><br />
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col-12 col-md-6 col-lg-3 col-xl-3 col-sm-12">
                    <button
                      @click="changePassword()"
                      type="button"
                      class="btn btn-danger btn-sm btn-block button-login"
                    >
                      <span
                        v-if="loadingUpdate"
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <template v-else>Cambiar</template>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal preguntar cambio  -->

    <div
      class="modal fade"
      id="questions"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="questionsLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered border-danger "
        role="document"
      >
        <div class="modal-content modal-question">
          <div class="modal-body">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12">
                <label style="color: #616161;">
                  Por tu seguridad, te recomendamos cambiar tu contraseña por
                  una más segura. </label
                ><br />
                <label style="color: #616161;">
                  <b>¿Quieres hacerlo?</b>
                </label>
              </div>
              <div class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3">
                <button
                  @click="openChange()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <span
                    v-if="loadingUpdate"
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <template v-else>Quiero cambiar</template>
                </button>
              </div>
              <div
                class="col-10 col-md-5 col-lg-4 col-xl-4 col-sm-10 mt-3 mb-3"
              >
                <button
                  data-dismiss="modal"
                  aria-label="Close"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <span
                    v-if="loadingUpdate"
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <template v-else>Más tarde</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal correcto -->

    <div
      class="modal fade "
      id="alertModal"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="alertModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered " role="document">
        <div class="modal-content modal-question">
          <div class="modal-body">
            <div class="row justify-content-center">
              <div class="col-12 ">
                <h5 class="text-danger">
                  <b> ¡Listo! Tu contraseña se ha actualizado </b>
                </h5>
                <br />
              </div>
            </div>
            <div class="row justify-content-center">
              <div class="col-12">
                <img alt="bien" class="img-etiqueta" src="../../assets/icon/bien.png" />
              </div>
            </div>
            <div class="row mt-4 justify-content-center">
              <div class="col-7">
                <h5 style="color: #616161;">
                  <b> Bienvenido a Havoline Motoclub Te Cubre </b>
                </h5>
              </div>
            </div>
            <div class="row mt-4 justify-content-center">
              <div class="col-5">
                <button
                  data-dismiss="modal"
                  aria-label="Close"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <span
                    v-if="loadingUpdate"
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <template v-else>Aceptar</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ACTUALIZACIÓN -->

    <div
      class="modal fade "
      id="gender"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-gender-con"
        role="gender"
      >
        <div class="modal-content modal-gender">
          <div class="modal-body img-gender pt-5 pb-5">
            <div class="row justify-content-center">
              <div class="col-12">
                <p class="title-gender">¡FELICIDADES!</p>
                <p class="title-gender-1">Bienvenido al Motoclub</p>
              </div>
              <div
                class="col-12 col-md-12 col-lg-8 col-xl-8 col-sm-12"
                style="text-align: center"
              >
                <label class="subtitle-gender">
                  Havoline te entrega
                </label>
                <label class="subtitle-gender-1"> &nbsp; 3 puntos</label>
                <label class="subtitle-gender">
                  por actualizar tus datos.
                </label>
              </div>
              <div class="col-12 col-md-12 col-lg-5 col-xl-5 col-sm-12 ">
                <button class="btn btn-block mt-4" @click="openModel()" style="background-color: #bc0012; color: #fff">
                  Actualizar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Actualización de datos usuario registrado por google -->
    <!-- <div
      class="modal fade "
      id="originGoogle"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered modal-gender-con"
        role="gender"
      >
        <div class="modal-content modal-gender">
          <div class="modal-body img-gender pt-5 pb-5">
            <div class="row justify-content-center">
              <div class="col-12">
                <p class="title-gender">¡FELICIDADES!</p>
                <p class="title-gender-1">Bienvenido al Motoclub</p>
              </div>
              <div
                class="col-12 col-md-12 col-lg-8 col-xl-8 col-sm-12"
                style="text-align: center"
              >
                <label class="subtitle-gender">
                  debes completar la información del registro
                </label>
              </div>
              <div class="col-12 col-md-12 col-lg-5 col-xl-5 col-sm-12 ">
                <button class="btn btn-block mt-4" @click="Redirect()" style="background-color: #bc0012; color: #fff">
                  Ir
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { mapState } from "vuex";
import navbarUser from "../../components/navbarUser.vue";
import footerLanding from "../../components/footerLanding.vue";
import $ from "jquery";
import axios from "axios";

export default {
  components: {
    navbarUser: navbarUser,
    footerLanding: footerLanding
  },
  computed: {
    ...mapState(["dataUser"])
  },
  data() {
    return {
      dataUser: [],
      roleUser: null,
      infoUser: {},
      loadingUpdate: false,
      disableLoadingSend: false,
      errors: {
        currentPassword: false,
        pass: false,
        pass_confirmation: false
      },
      form: {
        currentPassword: "",
        pass: "",
        pass_confirmation: ""
      },
      showBtn: false,
    };
  },
  watch: {
    "form.currentPassword": function(n) {
      if (!n) {
        this.errors.currentPassword = "La contraseña es requerida.";
      } else {
        this.errors.currentPassword = false;
      }
    },
    "form.pass": function(n) {
      if (!n) {
        this.errors.pass = "La contraseña es requerida.";
      } else if (!this.validPassword(n)) {
        this.errors.pass =
          "La contraseña es inválida, debe tener entre 8 a 16 carácteres, al menos un dígito, al menos una minúscula y al menos una mayúscula. Puede tener otros símbolos.";
      } else {
        this.errors.pass = false;
      }
      if (this.form.pass_confirmation == this.form.pass) {
        this.errors.pass_confirmation = false;
      } else {
        this.errors.pass_confirmation = "Las contraseñas deben ser iguales";
      }
    },
    "form.pass_confirmation": function() {
      if (this.form.pass_confirmation == this.form.pass) {
        this.errors.pass_confirmation = false;
      } else {
        this.errors.pass_confirmation = "Las contraseñas deben ser iguales";
      }
    }
  },
  methods: {
    openModel() {
      $('#gender').modal('hide');
      setTimeout(function() {
        $('#exampleModalUpdate').modal('show');
      }, 500);
      if (this.infoUser.validatePass == 0) {
        $("#exampleModalUpdate").modal("show");
      }
    },
    // Redirect(){
    //   this.$router.push({ name: "registerGoogle" });
    //   $("#originGoogle").modal("hide");
    // },
    openChange() {
      $("#questions").modal("hide");
      $("#exampleModal").modal("show");
    },
    validPassword(pass) {
      var re = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;
      return re.test(pass);
    },
    validateForm() {
      if (!this.form.currentPassword) {
        this.errors.currentPassword = "La contraseña es requerida.";
      }
      if (!this.form.pass) {
        this.errors.pass = "La contraseña es requerida.";
      }

      if (!this.form.pass_confirmation) {
        this.errors.pass_confirmation = "La contraseña es requerida.";
      }

      if (this.form.pass_confirmation != this.form.pass) {
        this.errors.pass_confirmation = "Las contraseñas deben ser iguales";
      }

      if (
        !this.errors.pass &&
        !this.errors.pass_confirmation &&
        !this.errors.currentPassword &&
        !this.validPassword(this.errors.pass)
      ) {
        return true;
      }

      return false;
    },
    validateCurrentGender() {
      axios
          .get("api/showUser")
          .then(function(res) {
            // console.log(res.data.User.gender_id);
            if (res.data.User.gender_id == 4 && res.data.User.register_origin != 3){
              // $("#gender").modal("show");
            }
            // if (res.data.User.gender_id == 4 && res.data.User.register_origin == 3){
            //   $("#originGoogle").modal("show");
            // }
          })
          .catch(function(error) {
            console.log(error);
          });
    },
    changePassword() {
      this.form.email = this.infoUser.email;
      if (this.validateForm()) {
        this.loadingUpdate = true;
        axios
          .post("api/changePassword", this.form)
          .then(res => {
            if (res.data.ResponseCode == 0) {
              $("#exampleModal").modal("hide");
              $("#alertModal").modal("show");
              var data1 = {
                email: this.infoUser.email,
                validatePass: 1
              };
              sessionStorage.removeItem("infoUser");
              sessionStorage.setItem("infoUser", JSON.stringify(data1));
            } else {
              this.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.ResponseMessage
              });
            }
            this.loadingUpdate = false;
          })
          .catch(error => {
            this.loadingUpdate = false;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.ResponseMessage
            });
          });
      }
    },
    getDataUser(){
      var app = this;
      axios
      .get("api/showUser")
      .then(function(res) {
        if(res.data.ResponseCode == 0){
          app.dataUser = res.data.User;
          app.roleUser = app.dataUser.role_id;
          app.getFlagUser();
        }
      })
      .catch(function(error) {
        console.log(error);
      });
    },
    getFlagUser(){
      axios
      .get("api/dataUser")
      .then((response) => {
        if(response.data.cod == 0){
          let userData = response.data.data;
          if(userData == null){
            this.showBtn = true;
          } else {
            userData.forEach(user => {
              if (user.link == 'null' || user.link == null){
                this.showBtn = false;
              }
              else{
                this.showBtn = true;
              }
            });
          }
        }
      })
      .catch(error => {
        // console.log(error);
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: error.response.data.message
        });
      });
    },
    irUpdateData(){
      this.$router.push({ name: "updateDataUser" });
    },
    showPass(type){
      if(type == 1){
        let pass = this.$refs.current_password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass1').addClass('fa-eye');
          $('#pass1').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass1').addClass('fa-eye-slash');
          $('#pass1').removeClass('fa-eye');
        }
      } 
      else if(type == 2){
        let pass = this.$refs.password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass2').addClass('fa-eye');
          $('#pass2').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass2').addClass('fa-eye-slash');
          $('#pass2').removeClass('fa-eye');
        }
      } else {
        let pass = this.$refs.confirm_password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass3').addClass('fa-eye');
          $('#pass3').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass3').addClass('fa-eye-slash');
          $('#pass3').removeClass('fa-eye');
        }
      }
    },
  },
  created() {
    this.infoUser = JSON.parse(sessionStorage.getItem("infoUser"));
  },
  mounted() {
    if (this.infoUser.gender == 4) {
      this.validateCurrentGender();
    } else {
      if (this.infoUser.validatePass == 0) {
        $("#exampleModal").modal("show");
      }
    }
    this.getDataUser();
  }
};
</script>

<style>
.title-gender {
    color: #bc0012;
    margin-bottom: 0px;
    font-size: 40px;
    font-family: "Gotham-UltraItalic";
}
.title-gender-1 {
    color: #bc0012;
    margin-bottom: 0px;
    font-size: 36px;
    font-weight: bold;
    font-family: "ubuntu-italic";
}
.subtitle-gender {
  color: #bc0012;
  font-size: 25px;
  margin-bottom: 0px;
  font-weight: bold;
  font-family: "ubuntu-italic";
}
.subtitle-gender-1 {
  color: #000;
  font-size: 23px;
  font-family: "ubuntu-italic";
  font-weight: bold;
}
.img-gender {
  border-radius: 8px;
  height: 100%;
  width: 600px;
  background-position: center;
  background-image: url("./../../assets/img/gender.jpg");
}
.modal-gender {
  width: 610px !important;
  border-radius: 25px !important;
}
.modal-question {
  border: solid 3px;
  border-color: #dc3545;
  border-radius: 15px;
}
.icon-style {
  font-size: 25px;
  color: #dc3545;
  padding: 6px;
}
.modal-title.title-change {
  color: #dc3545 !important;
  font-weight: bold;
}
.table td,
.table th {
  vertical-align: middle !important;
}
body {
  padding-right: 0px !important;
}
.eye_pass{
  position: absolute;
  height: 100%;
  right: 5%;
  padding-top: 4px;
  cursor: pointer;
  z-index: 1000;
}

@font-face {
  font-family: "ubuntu-italic";
  src: url("./../../assets/font/Ubuntu-Italic.ttf");
  font-display: swap;
  /* font-display: auto; */
}
@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
  /* font-display: auto; */
}

/* MOBILE */
@media (max-width: 767px) {
  .img-gender {
    width: 100%;
  }
  .title-gender {
    color: #000;
    font-size: 20px;
    font-family: "Gotham-UltraItalic";
  }
  .subtitle-gender {
    color: #000;
    font-size: 18px;
    font-family: "ubuntu-italic";
  }
}
.content_btn{
  position: fixed;
  bottom: 100px;
  right: 10px;
  z-index: 9999;
  width: 170px;
}
</style>
